import React__default from 'react';
import styled from 'styled-components';
import { setTestId } from '../../lib/testId.js';

const IFrame = styled.iframe`
  height: 100%;
  width: 100%;
  border: none;
  overflow: scroll;
`;
const IFrameEmbed = ({ testId ="X" , children , forwardedRef , src , ...props })=>{
    return React__default.createElement(IFrame, {
        "data-hpy-web-iframe": true,
        ...props,
        ...setTestId("IFrameEmbed-" + testId),
        ref: forwardedRef,
        src: src
    }, children);
};
IFrameEmbed.dataId = "data-hpy-web-iframe";
IFrameEmbed.displayName = "IFrameEmbed";

export { IFrameEmbed };
